// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"UploadDocumentsPageView__infoBoxContainer-ctJq"};